import React, { Dispatch, SetStateAction } from 'react';

import { IPpdPricesDto } from '@r1-frontend/api-domru/ppd-service/dto/IPpdPricesDto';

import * as ST from './styled';

interface IProps {
    setSelected: Dispatch<SetStateAction<number>>,
    selected: number,
    dataPricesFiltered: IPpdPricesDto[],
}

const ChooserBlock: React.FC<IProps> = ({ selected, setSelected, dataPricesFiltered }) => {

    if ((!dataPricesFiltered || !dataPricesFiltered.length)) {
        return null;
    }

    return (
        <>
            {dataPricesFiltered.map((element: IPpdPricesDto, key) => {
                return <ST.RadioContainer key={element._id}>
                    <ST.RadioButton
                        label={element.nameForLanding}
                        checked={selected === key}
                        onChange={() => setSelected(key)}/>
                    <ST.Price data-test={'price'}>{element.price} ₽</ST.Price>
                </ST.RadioContainer>;
            })}
        </>
    );
};

export default ChooserBlock;
